var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"disabled":_vm.disabled,"placement":_vm.mappedPlacement}},[(!_vm.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("data")],2):_vm._e(),_vm._t("item")],2)}
var staticRenderFns = []

export { render, staticRenderFns }